import * as React from 'react';
import { useSelector } from 'react-redux';
import { AreaParts } from './AreaParts';
import { selectIsAreaParts } from '../../../../selectors/offer';

export const AreaPartsContainer = () => {
  const isAreaParts = useSelector(selectIsAreaParts);

  if (!isAreaParts) {
    return null;
  }

  return <AreaParts />;
};
